/* tslint:disable */
/* eslint-disable */
/**
 * Illio Wealth API
 * [Environment: dev], Manage your account, add trades, view portfolio performance and pnl
 *
 * The version of the OpenAPI document: 1.0
 * Contact: support@illio.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { SourceId } from './source-id';

/**
 * 
 * @export
 * @interface EnhancedInstrumentSearchResult
 */
export interface EnhancedInstrumentSearchResult {
    /**
     * 
     * @type {string}
     * @memberof EnhancedInstrumentSearchResult
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhancedInstrumentSearchResult
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhancedInstrumentSearchResult
     */
    'exchange'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhancedInstrumentSearchResult
     */
    'currency'?: EnhancedInstrumentSearchResultCurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof EnhancedInstrumentSearchResult
     */
    'assetClass'?: EnhancedInstrumentSearchResultAssetClassEnum;
    /**
     * 
     * @type {SourceId}
     * @memberof EnhancedInstrumentSearchResult
     */
    'sourceId': SourceId;
    /**
     * 
     * @type {number}
     * @memberof EnhancedInstrumentSearchResult
     */
    'pointValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof EnhancedInstrumentSearchResult
     */
    'assetSubClass'?: EnhancedInstrumentSearchResultAssetSubClassEnum;
    /**
     * 
     * @type {string}
     * @memberof EnhancedInstrumentSearchResult
     */
    'instrumentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnhancedInstrumentSearchResult
     */
    'instrumentStatus'?: EnhancedInstrumentSearchResultInstrumentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof EnhancedInstrumentSearchResult
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnhancedInstrumentSearchResult
     */
    'fxRate'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum EnhancedInstrumentSearchResultCurrencyEnum {
    Eur = 'EUR',
    Gbp = 'GBP',
    Aud = 'AUD',
    Nzd = 'NZD',
    Usd = 'USD',
    Kwd = 'KWD',
    Jod = 'JOD',
    Chf = 'CHF',
    Cad = 'CAD',
    Sgd = 'SGD',
    Ils = 'ILS',
    Qar = 'QAR',
    Aed = 'AED',
    Sar = 'SAR',
    Pln = 'PLN',
    Myr = 'MYR',
    Brl = 'BRL',
    Ron = 'RON',
    Try = 'TRY',
    Cny = 'CNY',
    Cnh = 'CNH',
    Hkd = 'HKD',
    Nok = 'NOK',
    Sek = 'SEK',
    Zar = 'ZAR',
    Egp = 'EGP',
    Mxn = 'MXN',
    Czk = 'CZK',
    Twd = 'TWD',
    Thb = 'THB',
    Uyu = 'UYU',
    Php = 'PHP',
    Ars = 'ARS',
    Rub = 'RUB',
    Inr = 'INR',
    Jpy = 'JPY',
    Isk = 'ISK',
    Pkr = 'PKR',
    Huf = 'HUF',
    Ngn = 'NGN',
    Krw = 'KRW',
    Idr = 'IDR',
    Dkk = 'DKK',
    Vnd = 'VND',
    Clp = 'CLP',
    Gbx = 'GBX',
    Ila = 'ILA',
    Zac = 'ZAC'
}
/**
    * @export
    * @enum {string}
    */
export enum EnhancedInstrumentSearchResultAssetClassEnum {
    CashAndEquivalents = 'CashAndEquivalents',
    Equities = 'Equities',
    FixedIncome = 'FixedIncome',
    RealEstate = 'RealEstate',
    Alternatives = 'Alternatives',
    Commodities = 'Commodities',
    RealAssets = 'RealAssets',
    CryptoCurrencies = 'CryptoCurrencies',
    SubscriptionWithdrawal = 'SubscriptionWithdrawal',
    Funds = 'Funds',
    Adjustments = 'Adjustments',
    Cfd = 'CFD',
    Fx = 'Fx'
}
/**
    * @export
    * @enum {string}
    */
export enum EnhancedInstrumentSearchResultAssetSubClassEnum {
    SubCash = 'SubCash',
    CshCash = 'CshCash',
    CshTermDeposit = 'CshTermDeposit',
    CshMoneyMarket = 'CshMoneyMarket',
    CshCommercialPaper = 'CshCommercialPaper',
    CshCashFunds = 'CshCashFunds',
    AdjFees = 'AdjFees',
    AdjFxSpot = 'AdjFXSpot',
    AdjIncome = 'AdjIncome',
    AdjPnL = 'AdjPnL',
    AdjInterest = 'AdjInterest',
    EqShares = 'EqShares',
    EqEtfs = 'EqETFs',
    EqWarrants = 'EqWarrants',
    EqOptions = 'EqOptions',
    EqIndex = 'EqIndex',
    EqPreferenceShares = 'EqPreferenceShares',
    EqUnlisted = 'EqUnlisted',
    EqCfd = 'EqCfd',
    EqStruct = 'EqStruct',
    EqFutures = 'EqFutures',
    FutOptions = 'FutOptions',
    FutIndex = 'FutIndex',
    FiBonds = 'FiBonds',
    FiEtf = 'FiETF',
    FiLoans = 'FiLoans',
    FiStructuredProducts = 'FiStructuredProducts',
    FiOptions = 'FiOptions',
    FiCds = 'FiCDS',
    FiDistressedDebt = 'FiDistressedDebt',
    FiIndex = 'FiIndex',
    FiConvertibles = 'FiConvertibles',
    FiCoCosAt1sEtc = 'FiCoCosAT1sEtc',
    FiMortgage = 'FiMortgage',
    FiMoneyMarket = 'FiMoneyMarket',
    FiTermDep = 'FiTermDep',
    FiFcn = 'FiFcn',
    FiFutures = 'FiFutures',
    RePhysical = 'RePhysical',
    ReReit = 'ReREIT',
    ReEquity = 'ReEquity',
    ReLoan = 'ReLoan',
    ReIndex = 'ReIndex',
    ReEtf = 'ReETF',
    AltDirectInvestments = 'AltDirectInvestments',
    AltIndex = 'AltIndex',
    ComPhysical = 'ComPhysical',
    ComNonPhysical = 'ComNonPhysical',
    ComIndices = 'ComIndices',
    ComEtfs = 'ComETFs',
    ComOptions = 'ComOptions',
    ComCfd = 'ComCfd',
    ComStruct = 'ComStruct',
    ComFutures = 'ComFutures',
    RaArt = 'RaArt',
    RaWineAndSpirits = 'RaWineAndSpirits',
    RaMotorVehicle = 'RaMotorVehicle',
    RaYacht = 'RaYacht',
    RaJewellery = 'RaJewellery',
    RaAircraft = 'RaAircraft',
    RaOther = 'RaOther',
    RaDigital = 'RaDigital',
    RaLivestock = 'RaLivestock',
    RaHorses = 'RaHorses',
    CryptoCurrencies = 'CryptoCurrencies',
    CryptoIndex = 'CryptoIndex',
    CryptoTokens = 'CryptoTokens',
    CryptoStablecoins = 'CryptoStablecoins',
    CryptoOptions = 'CryptoOptions',
    CryptoStruct = 'CryptoStruct',
    CryptoFutures = 'CryptoFutures',
    FunEquity = 'FunEquity',
    FunEtf = 'FunETF',
    FunFixedIncome = 'FunFixedIncome',
    FunMixed = 'FunMixed',
    FunSpeciality = 'FunSpeciality',
    FunRealEstate = 'FunRealEstate',
    FunCommodity = 'FunCommodity',
    FunMoneyMarket = 'FunMoneyMarket',
    FunAlternatives = 'FunAlternatives',
    FunAltHedgeFunds = 'FunAltHedgeFunds',
    FunAltPrivateEquity = 'FunAltPrivateEquity',
    PrivateEquityVc = 'PrivateEquityVC',
    FunAltVentureCapital = 'FunAltVentureCapital',
    FunAltFundOfFunds = 'FunAltFundOfFunds',
    FunOther = 'FunOther',
    FundCfd = 'FundCfd',
    FundStruct = 'FundStruct',
    CfdOther = 'CFDOther',
    FxOptions = 'FxOptions',
    FxFwd = 'FxFwd',
    FxTarf = 'FxTarf',
    FxStruct = 'FxStruct',
    FxFutures = 'FxFutures'
}
/**
    * @export
    * @enum {string}
    */
export enum EnhancedInstrumentSearchResultInstrumentStatusEnum {
    Draft = 'DRAFT',
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
    Delisted = 'DELISTED',
    Suspended = 'SUSPENDED',
    Deprecated = 'DEPRECATED',
    Error = 'ERROR'
}


